// jscpd:ignore-start
import { isPlatformBrowser } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core'
import { ApiService } from 'src/app/core/services/api.service'
import { ChatState } from 'src/app/core/services/chat.service'
import { PageService } from 'src/app/core/services/page.service'
import { SESSION_TIMER_MINUTES } from '../options-utils/modal-shared'
import { SharedDataService } from '../../../../core/services/shared-data.service'
// jscpd:ignore-end
@Component({
    selector: 'app-modal-options-credit-lock',
    templateUrl: './modal-options-credit-lock.component.html',
    styleUrls: ['../modal-options.component.scss', './modal-options-credit-lock.component.scss'],
    standalone: false
})
export class ModalOptionsCreditLockComponent implements OnInit {
  isLoading = false
  @Input() loanData = null
  @Input() dev = false
  @Input() mobileNumber = ''
  @Output() unlock: EventEmitter<any> = new EventEmitter()
  @Output() closeModal: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  @Input() breakpoints: any = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true
  }

  isSessionTimeout = false
  rmTimeout = null

  constructor(
    private api: ApiService,
    public page: PageService,
    private cdr: ChangeDetectorRef,
    public sharedDataService: SharedDataService,
    @Inject(PLATFORM_ID) private platformId: object,
    private chatState: ChatState) { }



  ngOnInit(): void {
    this.toggleLoader.emit(false)
    this.cdr.detectChanges()
    if (isPlatformBrowser(this.platformId)) {
      this.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
    }
  }

  showChat(){
    this.chatState.toggleChat(true)
  }

  repullFreeze() {
    this.isLoading = true
    this.toggleLoader.emit(true)
    let body
    if (this.loanData) {
      body = {
        userId: this.loanData.userId,
        loanId: this.loanData.loanId,
        channelId: this.loanData.channelId
      }
    }
    if (this.dev) {
      const transactionId = 'ac6a71bd-5880-4047-a232-41c1c83b40a8'
      this.api.rePullFreezeSyntetic(body, transactionId).subscribe(data => {
        this.toggleLoader.emit(false)
        if (data.nextStep === 'Pre_LO_Credit_Freeze') {
          return
        }
        this.unlock.emit(data)
        this.isLoading = false
      }, (error: any) => {
        this.isLoading = false
        this.toggleLoader.emit(false)
        console.error(error)
      })
    }
    else {
      this.api.rePullFreeze(body).subscribe(data => {
        this.toggleLoader.emit(false)
        if (data.nextStep === 'Pre_LO_Credit_Freeze') {
          return
        }
        this.unlock.emit(data)
        this.isLoading = false
      }, (error: any) => {
        this.isLoading = false
        this.toggleLoader.emit(false)
        console.error(error)
      })
    }
  }


  onSessionPopupToClose() {
    this.isSessionTimeout = false
    if (this.breakpoints.extraSmall) {
      this.page.goAndScroll('/', 'mobileHeader')
    }
    else {
      this.page.goAndScroll('/', 'topHeader')
    }
    this.closeModal.emit()
  }

  onSessionPopupContinue() {
    this.isSessionTimeout = false
    this.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
  }


  setRunTimerByTimeout(minutes?) {
    if (!minutes) {
      minutes = 9
    }
    if (this.rmTimeout) {
      clearTimeout(this.rmTimeout)
    }
    this.rmTimeout = this.rmDataByTimeout(minutes)
  }


  rmDataByTimeout(minutes: number) {
    return setTimeout(() => {
      this.isSessionTimeout = true
    }, minutes * 60 * 1000)
  }



}
